/* eslint-disable ember/classic-decorator-hooks, ember/no-classic-components, ember/no-computed-properties-in-native-classes, ember/require-tagless-components */
import Component from '@ember/component';
import { tracked } from '@glimmer/tracking';
import { action, computed } from '@ember/object';

export default class AssessmentSection extends Component {
  // Props
  // person provides the person model to display an assessment overview for.
  person = null;

  // assessments is an array of assessments to show overviews for.
  assessments = null;

  // modules is an array of assessment modules to include in the overviews.
  modules = null;

  // grades is an array of the grades to be displayed in the overviews.
  grades = null;

  // hideHeader hides the section label when true.
  hideHeader = false;

  // collapsible enables a hide/show toggle per assessment.
  collapsible = false;

  // startCollapsed starts all assessments in the collapsed state.
  startCollapsed = false;

  @tracked
  collapsedAssessments;

  init() {
    super.init(...arguments);
    let initial = {};
    if (this.startCollapsed && this.assessments) {
      this.assessments.forEach((a) => {
        initial[a.get('id')] = true;
      });
    }
    this.collapsedAssessments = initial;
  }

  @computed('collapsedAssessments')
  get collapsedState() {
    return this.collapsedAssessments;
  }

  @action
  toggleAssessment(assessmentId) {
    let current = Object.assign({}, this.collapsedAssessments);
    current[assessmentId] = !current[assessmentId];
    this.collapsedAssessments = current;
  }
}
